class APIRequest {
  constructor(baseURL) {
    this.baseURL = baseURL || '/api';
    this.retryTime = 1000 * 5;
  }

  async request(
    endpoint,
    method = 'GET',
    body = null,
    authToken = null,
    queryParams = {},
    headers = {},
    abortController = null
  ) {
    const queryString = queryParams
      ? Object.keys(queryParams)
          .map(k => `${k}=${encodeURIComponent(queryParams[k])}`)
          .join('&')
      : '';

    const url = `${this.baseURL}${endpoint}${queryString ? `?${queryString}` : ''}`;

    headers = {
      Accept: 'application/json',
      ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...headers,
    };

    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const options = {
      method,
      headers,
      signal: abortController?.signal,
    };

    if (body && !['GET', 'HEAD', 'DELETE'].includes(method)) {
      options.body = body instanceof FormData ? body : JSON.stringify(body);
    }

    return this.fetcher(url, options);
  }

  async fetcher(url, options) {
    const response = await fetch(url, options);
    const status = response.status;

    let data;
    try {
      data = await response.json();
    } catch {
      data = {};
    }

    // If data is an array, we should return it as is or wrap it properly
    // Spreading an array into an object { ...data } converts it to indexed object {0:..., 1:...}
    if (Array.isArray(data)) {
      return { data, response_code: status };
    }

    return { ...data, response_code: status };
  }
}

export default APIRequest;
